module.exports = __webpack_public_path__ + "static/img/jiqiren.2832e0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jiqiren.png
// module id = Xg4J
// module chunks = 1